<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
          <base-tooltip-icon v-if="tooltipText" size="sm" :section="header" :content="tooltipText" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div ref="value">
              
              <accessible-el-select
                prop="value"
                v-model="form.value"
                remote
                :remoteMethod="remoteOrganismos" 
                popperClass="wrap-select-popover"
                :options="valuesOrganismos.map(x => ({ id: x.id, value: x.id, name: x.label }))"
                id-prefix="inputselectorgprovincesdialog"
                :isDisabled="loadingOrganismos"
              >
                <template #label>
                  <div class="flex items-center gap-x-2">
                    <base-obligatory-icon/>{{headerValue}}
                    <base-tooltip-icon size="sm" :section="headerValue" :content="'Escribe para iniciar la búsqueda'"/>
                  </div>
                </template>
              </accessible-el-select>
              
            </div>
          </div>
          <div class="lg:mb-2">
            <div>
              <label for="id-switch-org-province" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('organismoprovincia.asign')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="id-switch-org-province"
                :aria-label="$t('organismoprovincia.asign')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.switch" 
                :active-text="$t('companies.active')"/>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          class="w-full"
          :loading="loadingOrganismos"
          :disabled="loadingOrganismos"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" 
          :loading="loadingOrganismos"
          :disabled="loadingOrganismos"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getOrganismoProvinciaByNEO } from '@/services/notifications/getOrganismoProvinciaByNEO'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'input-select-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect,
  },
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    headerValue: {
      type: String,
      default: 'Valor'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: null,
    },
    idCliente: {
      type: Number,
      default: -1,
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        value: null,
        switch: false,
      },
      valuesOrganismos: [],
      loadingOrganismos: false,
      rules: {
        value: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
    }
  },
  mounted: async function () {
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.loadingOrganismos) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.value = null
      this.form.switch = false
      this.valuesOrganismos = []
    },
    apply: function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form)
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    formatNombreOrgProvince (element) {
      return element.CodigoOrganismo + ' - ' + 
        element.NombreOrganismo + ' / ' + 
        element.CodigoProvincia + ' - ' + 
        element.NombreProvincia
    },
    remoteOrganismos: async function (query) {
      this.valuesOrganismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismoProvinciaByNEO({ filtro: query, idCliente: this.idCliente })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.respuesta !== undefined && organismos.respuesta.length > 0) {
            let organismosMatch = []
            if (organismos.respuesta.length > 200) {
              organismosMatch = organismos.respuesta.filter(x => 
                x.CodigoProvincia.toUpperCase() === query.toUpperCase() || 
                x.NombreProvincia.toUpperCase() === query.toUpperCase() || 
                x.CodigoOrganismo.toUpperCase() === query.toUpperCase() || 
                x.NombreOrganismo.toUpperCase() === query.toUpperCase()
              )
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.respuesta
            }
            organismosMatch.forEach(element => {
              this.valuesOrganismos.push(
                { 
                  id: element.idOrganismoProvincia, 
                  label: this.formatNombreOrgProvince(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      } else {
        // this.options = []
      }
    }
  }
}
</script>

